import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { NavController } from '@ionic/angular';
import { AnalycticsNativeService } from '../../service/comunicator-native/analytics-native/analyctics-native';
import { BackNativeService } from '../../service/comunicator-native/back-native/back-native';
import { ReturnNativeService } from '../../service/comunicator-native/return-native/return-native';
import { JourneyService } from '../../service/journey/journey.service';
import { DefaultPageComponent } from '../default-page.component';
import { ParamDefaultGA4 } from '../../service/comunicator-native/track-ga4-native/itrack-ga4-native';
import { AnalyticsGA4PageService } from '../../service/analytics-ga4-pages/analytics-ga4-page.service';
interface AnalyticsPageDetail {
  pageName: string;
  action: string;
  back: string;
}
interface AnalyticsGA4Page {
  paramDefautl: ParamDefaultGA4, 
  paramComplementary?: Record<string, string>
}
@Component({
  selector: 'app-details',
  templateUrl: './details.component.html',
  styleUrls: ['./details.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class DetailsComponent extends DefaultPageComponent implements OnInit {

  content: SafeHtml;
  titleContent: string;
  idFocusBack: string;
  ariaHidden = true;
  headerId = 'back-detail-page';
  labelBtnBack = 'voltar';
  pageLoaded: boolean;
  voicePageLoaded: boolean;
  analyticsPage: AnalyticsPageDetail;
  analyticsPageGA4: AnalyticsGA4Page;

  constructor(
    private sanitizer: DomSanitizer,
    public router: NavController,
    private route: Router,
    public journeyService: JourneyService,
    public returnNativeService: ReturnNativeService,
    public backNativeService: BackNativeService,
    private analycticsNativeService: AnalycticsNativeService,
    private analyticsGA4PageService: AnalyticsGA4PageService
  ) {
    super(backNativeService, journeyService, router, returnNativeService);
    this.loadData();
  }

  ngOnInit() {
    this.checkPageHasLoading();
  }

  checkPageHasLoading() {
    if (this.pageLoaded) {
      this.labelBtnBack = 'Tela carregada, voltar'
      this.headerFocus();
      setTimeout(() => this.labelBtnBack = 'voltar', 1000);
    } else {
      this.headerFocus();
    }
  }

  backPage() {
    if (this.analyticsPage) {
      this.analyticsEventClique();
    }

    localStorage.setItem(this.idFocusBack, this.idFocusBack);
    this.router.pop();
  }

  loadData() {
    const data = this.route.getCurrentNavigation().extras.state?.data;

    if (data) {
      this.titleContent = data?.title || data?.nome;
      this.content = this.sanitizer.bypassSecurityTrustHtml( data?.description || data?.conteudo );
      this.idFocusBack = data?.index;
      this.pageLoaded = data?.pageLoadedOnlyScreenReader;
      this.analyticsPage = data?.analyticsPage;
      this.analyticsPageGA4 = data?.analyticsPageGA4;
    }

    if (this.analyticsPage) {
      this.analyticsData();
    }

    if (this.analyticsPageGA4) {
      this.sendTrackGA4LoadPage();
    }
  }

  analyticsData() {
    const it_pagename = this.analyticsPage.pageName;
    this.analycticsNativeService.analyticsTrackStateCommunicator(it_pagename);
  }

  sendTrackGA4LoadPage() {
    const paramDefautl = {
      event_name: this.analyticsPageGA4.paramDefautl.event_name,
      custom_path: this.analyticsPageGA4.paramDefautl.custom_path,
      implementation_team: this.analyticsPageGA4.paramDefautl.implementation_team,
    }

    this.analyticsGA4PageService.sendTrackGA4(paramDefautl)
  }

  analyticsEventClique() {
    const it_eventcategory = 'Clique';
    const it_complementary = {
      it_eventaction: this.analyticsPage.action,
      it_eventlabel: this.analyticsPage.back,
      it_pagename: this.analyticsPage.pageName
    };
    this.analycticsNativeService.analyticsTrackActionCommunicator(it_eventcategory, it_complementary);
  }

}
